export class FormaDePagamento {

  constructor() {
    this.tipo = [
      { value: 'DIN', descricao: 'Dinheiro' },
      { value: 'BOL', descricao: 'Boleto' },
      { value: 'CHQ', descricao: 'Cheque' },
      { value: 'DEP', descricao: 'Depósito' },
      { value: 'TRA', descricao: 'Transferência' },
    ];
  }
  Id: number;
  Codigo: string;
  Descricao: string;
  CreditoDebito: string;
  CadastrarCheque: boolean;

  TacaCartao: number;
  TaxaJuros: number;
  PrazoRecebimento: number;
  MaximoParcelas: number;
  Ativo: boolean;
  tipo: any;
}
